import siteMetadata from '../../site-metadata';

const useSiteMetadata = () => siteMetadata;

export default useSiteMetadata;
